import { createFileRoute } from "@tanstack/react-router";
import { RoundPreviewScreen } from "@modules/rounds/views";

/**
 * `/rounds/$roundId` — « Aperçu du dossier », the public read of one round (US-E11-01).
 *
 * **The second route in the app with no `beforeLoad`**, and for the same reason as `/website`: it
 * reads an unauthenticated endpoint, so a guard here would defeat the point. This one goes further
 * — the story's core rule is that *reading the dossier must not create any record of the person
 * reading it*, and a guard that probed `/auth/me` would be a request about the visitor on a page
 * whose whole claim is that it makes none.
 *
 * It also does not resolve the round in `beforeLoad`, even though `ensurePublicRound` exists for
 * exactly that. Deliberate: a loader-side redirect would trade one honest "this round is
 * unavailable" page for a bounce back to the catalogue with no explanation, and on a public link
 * shared by a campaign the explanation is the useful part. The screen renders the failure itself
 * and does not distinguish 404 from 503 from 429 — a visitor cannot tell them apart, and telling
 * them a hidden round exists would be a leak.
 *
 * No `staticData.breadcrumb`: that is app-shell furniture and this screen renders outside it.
 */
export const Route = createFileRoute("/rounds/$roundId")({
  component: RoundPreviewRoute,
});

function RoundPreviewRoute() {
  const { roundId } = Route.useParams();
  return <RoundPreviewScreen roundId={roundId} />;
}
